import React from 'react';
import { rem } from '../../styles/rem';

import { SchemaFrontendUserDataViewModel } from '../../api/api-schema';
import { useAuth } from '../../api/AuthProvider';
import FrontPageInitiateDeclarationViewModel from '../../modules/FrontPage/types/FrontPageInitiateDeclarationViewModel';
import { ButtonVariant } from '../../styles/buttons';
import { FontWeight } from '../../styles/typography';
import Button from '../Button/Button';

type Props = {
  model?: FrontPageInitiateDeclarationViewModel;
  user?: SchemaFrontendUserDataViewModel;
  userReady?: boolean;
};

function InitiateFrontPage({ model, user, userReady }: Props) {
  const { loginUrl } = useAuth();

  return (
    <div
      sx={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {model?.link && (
        <Button
          variant={ButtonVariant.Primary}
          {...model.link}
          sx={{
            alignItems: 'center',
            display: 'inline-flex',
            height: rem(48),
            justifyContent: 'center',
            minWidth: rem(151),
            px: rem(32),
            py: 0,
          }}
        >
          {model.link?.label}
        </Button>
      )}
      <div
        data-auth-login-placeholder={!userReady ? '' : undefined}
        sx={{
          alignItems: 'center',
          mb: [0],
          ml: [rem(28), rem(28), rem(28)],
          display: 'flex',
          height: rem(48),
          justifyContent: 'center',
        }}
      >
        {!user && model?.loginLabel && (
          <Button
            variant={ButtonVariant.Flat}
            external
            prefetch={false}
            href={loginUrl}
            sx={{
              alignItems: 'center',
              display: 'inline-flex',
              fontWeight: FontWeight.Medium,
              height: rem(48),
              marginTop: 0,
              px: rem(16),
              py: 0,
            }}
          >
            {model.loginLabel}
          </Button>
        )}
      </div>
    </div>
  );
}

export default InitiateFrontPage;
